/** Mirrors enrollio-be WeekChargeStatus. */
export enum WeekChargeStatus {
  BILLABLE = 'billable',
  PREPAID = 'prepaid',
  POSTED = 'posted',
  CAPPED = 'capped',
  OUT_OF_CHART = 'out_of_chart',
}

/** Mirrors enrollio-be HourlyTuitionPostingStatus. */
export enum HourlyTuitionPostingStatus {
  NONE = 'none',
  PARTIAL = 'partial',
  FULL = 'full',
}

/** Mirrors enrollio-be HourlyTuitionDiscountType. */
export enum HourlyTuitionDiscountType {
  FIXED = 'fixed',
  PERCENTAGE = 'percentage',
}

export const HOURLY_TUITION_DISCOUNT_TYPES = [
  HourlyTuitionDiscountType.FIXED,
  HourlyTuitionDiscountType.PERCENTAGE,
] as const;

/** Mirrors enrollio-be HourlyTuitionPostStudentStatus (+ V1 already_processed). */
export enum HourlyTuitionPostStudentStatus {
  SUCCESS = 'success',
  FAILED = 'failed',
  /** V1 hourly-tuition-billing only. */
  ALREADY_PROCESSED = 'already_processed',
  ALREADY_POSTED = 'already_posted',
  SKIPPED_PREPAID = 'skipped_prepaid',
  NO_BILLABLE_WEEKS = 'no_billable_weeks',
  NOT_ENROLLED = 'not_enrolled',
  NOT_FOUND = 'not_found',
}

/** Mirrors enrollio-be HourlyTuitionBatchOutcome. */
export enum HourlyTuitionBatchOutcome {
  SUCCESS = 'success',
  PARTIAL = 'partial',
  FAILED = 'failed',
}

/** Skip-only post statuses returned before charge attempt. */
export const HOURLY_TUITION_POST_SKIP_STATUSES: HourlyTuitionPostStudentStatus[] =
  [
    HourlyTuitionPostStudentStatus.ALREADY_PROCESSED,
    HourlyTuitionPostStudentStatus.ALREADY_POSTED,
    HourlyTuitionPostStudentStatus.SKIPPED_PREPAID,
    HourlyTuitionPostStudentStatus.NO_BILLABLE_WEEKS,
    HourlyTuitionPostStudentStatus.NOT_ENROLLED,
    HourlyTuitionPostStudentStatus.NOT_FOUND,
  ];

export function isHourlyTuitionPostSkipStatus(
  status: HourlyTuitionPostStudentStatus,
): boolean {
  return HOURLY_TUITION_POST_SKIP_STATUSES.includes(status);
}

/** Enrollment roster status shown in mapped preview rows. */
export enum EnrollmentRosterStatus {
  ACTIVE = 'active',
}

/** Mirrors enrollio-be HourlyTuitionWarning.code. */
export enum HourlyTuitionWarningCode {
  OVERLAPPING_POST = 'overlapping_post',
}
